import {DECK_BACKING_PADDING_TOP_BY_SHADOW_COUNT_REM, HOMEMATCH_TINDER_MAX_SHADOWS} from "../constants/homematch_tinder_deck_shadows";
import {HOMEMATCH_TINDER_DETAILS_CONTENT} from "../constants/homematch_tinder_details_content";

interface IDeckItem {
    id: number;
}

interface IOfferCounterParams {
    preleadId: number;
    remainingPreleadsList: IDeckItem[];
    trackingIndex: number;
}

export const getTinderDeckOfferCounter = (params: IOfferCounterParams) => {
    const {preleadId, remainingPreleadsList, trackingIndex} = params;
    const isCurrentInRemaining = remainingPreleadsList.some((item) => item.id === preleadId);
    const total = trackingIndex + remainingPreleadsList.length + (isCurrentInRemaining ? 0 : 1);

    return {
        position: trackingIndex + 1,
        total
    };
};

export const getTinderDeckOfferCounterLabel = (params: IOfferCounterParams): string | undefined => {
    const {remainingPreleadsList} = params;

    if (remainingPreleadsList.length === 0) return undefined;

    const {position, total} = getTinderDeckOfferCounter(params);

    if (total <= 0) return undefined;

    return HOMEMATCH_TINDER_DETAILS_CONTENT.getOfferCounterLabel(position, total);
};

export const getTinderDeckShadowKeys = (preleadId: number, remainingPreleadsList: IDeckItem[]) => {
    const currentIndexInRemaining = remainingPreleadsList.findIndex((item) => item.id === preleadId);

    return remainingPreleadsList.slice(currentIndexInRemaining + 1, currentIndexInRemaining + 1 + HOMEMATCH_TINDER_MAX_SHADOWS).map((item) => item.id);
};

export const getTinderDeckBackingPaddingTop = (shadowCount: number): string => {
    const clampedShadowCount = Math.min(Math.max(shadowCount, 0), HOMEMATCH_TINDER_MAX_SHADOWS);

    return `${DECK_BACKING_PADDING_TOP_BY_SHADOW_COUNT_REM[clampedShadowCount]}rem`;
};
import {DECK_BACKING_PADDING_TOP_BY_SHADOW_COUNT_REM, HOMEMATCH_TINDER_MAX_SHADOWS} from "../constants/homematch_tinder_deck_shadows";
import {HOMEMATCH_TINDER_DETAILS_CONTENT} from "../constants/homematch_tinder_details_content";

interface IDeckItem {
    id: number;
}

interface IOfferCounterParams {
    preleadId: number;
    remainingPreleadsList: IDeckItem[];
    trackingIndex: number;
}

export const getTinderDeckOfferCounter = (params: IOfferCounterParams) => {
    const {preleadId, remainingPreleadsList, trackingIndex} = params;
    const isCurrentInRemaining = remainingPreleadsList.some((item) => item.id === preleadId);
    const total = trackingIndex + remainingPreleadsList.length + (isCurrentInRemaining ? 0 : 1);

    return {
        position: trackingIndex + 1,
        total
    };
};

export const getTinderDeckOfferCounterLabel = (params: IOfferCounterParams): string | undefined => {
    const {remainingPreleadsList} = params;

    if (remainingPreleadsList.length === 0) return undefined;

    const {position, total} = getTinderDeckOfferCounter(params);

    if (total <= 0) return undefined;

    return HOMEMATCH_TINDER_DETAILS_CONTENT.getOfferCounterLabel(position, total);
};

export const getTinderDeckShadowKeys = (preleadId: number, remainingPreleadsList: IDeckItem[]) => {
    const currentIndexInRemaining = remainingPreleadsList.findIndex((item) => item.id === preleadId);

    return remainingPreleadsList.slice(currentIndexInRemaining + 1, currentIndexInRemaining + 1 + HOMEMATCH_TINDER_MAX_SHADOWS).map((item) => item.id);
};

export const getTinderDeckBackingPaddingTop = (shadowCount: number): string => {
    const clampedShadowCount = Math.min(Math.max(shadowCount, 0), HOMEMATCH_TINDER_MAX_SHADOWS);

    return `${DECK_BACKING_PADDING_TOP_BY_SHADOW_COUNT_REM[clampedShadowCount]}rem`;
};
